export default __webpack_public_path__ + "static/media/it.d9765a08.svg";